module.exports = __webpack_public_path__ + "img/newMate.88691cdd.svg";